import React, { useContext, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Container, Grid, LinearProgress } from '@mui/material';
import { PageHeader } from '../../common';
import { FetchContext, NavContext, NavRoutes } from '../../contexts';
import { ContattoContext, ContattoProvider } from './ContattoContext';
import { ContattiList, ContattoForm } from './components';

const PageContent = (props) => {

    const {
        user
    } = useContext(FetchContext);

    const {
        addBreadcrumbToken,
        setBread,
        goBack,
        navigateTo,
        getRouteTo
    } = useContext(NavContext);

    const {
        state,
        setState,

        isLoadingContatto,
        getContattoAsync,

        isUpdatingContatto,
        updateContattoAsync,

        isAddingContatto,
        addContattoAsync,

        isLoadingTipiContatti,
        getTipiContattiAsync,

        isDeletingContatto,
        deleteContattoAsync,

        isLoadingContatti,
        getContattiAsync,
    } = useContext(ContattoContext);

    const {
        contatto,
    } = state;

    const {
        ufficioId,
        contattoId,
    } = useParams();

    const formRef = useRef();
    const saveClickHandler = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    }

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading(isLoadingContatto || isUpdatingContatto || isAddingContatto);
    }, [isLoadingContatto, isUpdatingContatto, isAddingContatto]);

    const contattoFormActionClickHandler = async (action, data) => {
        switch (action) {
            case "Submit":
                if (contattoId) {
                    await updateContattoAsync(ufficioId, contattoId, data.tipoContattoId, data);
                } else {
                    await addContattoAsync(ufficioId, data.tipoContattoId, data);
                    goBack();
                }
                break;
            default:
                break;
        }
    }

    const contattiListActionClickHandler = async (action, data) => {
        switch (action) {
            case "Add":
                window.open(getRouteTo(NavRoutes.ContattoAdd, [ufficioId]), "_blank").focus();
                break;
            case "Delete":
                await deleteContattoAsync(ufficioId, data.id);
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        if (user && contatto)
            addBreadcrumbToken(contatto.descrizione);
    }, [contatto, user]);

    useEffect(() => {
        if (user) {
            if (contattoId) {
                getContattoAsync(ufficioId, contattoId);
                getContattiAsync(ufficioId, 0, 1000, contattoId);
            } else {
                addBreadcrumbToken("Aggiungi");
                setState({ contatto: { padreId: contatto?.id }, contatti: null });
            }
        }
    }, [contattoId, user]);

    useEffect(() => {
        if (user) {
            if (contattoId) {
                getContattoAsync(ufficioId, contattoId);
                getContattiAsync(ufficioId, 0, 1000, contattoId);
            }
            getTipiContattiAsync();
        }
    }, [user]);

    return (
        <>
            <Container>
                <Grid container>
                    {isLoading && <LinearProgress />}
                    <Grid item xs={12}>
                        <PageHeader
                            disabled={isLoading}
                            save
                            onSaveClick={saveClickHandler}
                            title={
                                <>
                                    {
                                        contatto ? "Attributo" : "Nuovo Attributo"
                                    }
                                </>
                            }
                            subtitle="Gestisci il attributo" />
                    </Grid>
                    <Grid item xs={12}>
                        <ContattoForm
                            formRef={formRef}
                            disabled={isLoading}
                            onActionClick={contattoFormActionClickHandler}
                        />
                    </Grid>
                    {
                        contattoId &&
                        <Grid item xs={12}>
                            <ContattiList
                                disabled={isLoading}
                                onActionClick={contattiListActionClickHandler}
                            />
                        </Grid>
                    }
                </Grid>
            </Container>
        </>
    );
}

export const ContattoPage = () => {

    return (
        <ContattoProvider>
            <PageContent />
        </ContattoProvider>
    );
}